/**
 * Builds class names for a bem component with modifiers:
 *
 * @example
 * bemComponentClasses("some-component", "active", "large")
 * outputs "some-component some-component--active some-component--large"
 */
export function bemComponentClasses(componentName: string, ...modifiers: Array<string | null | undefined>): string {
    const modifierClasses = modifiers
        .filter((modifier: string | null) => typeof modifier === "string")
        .map((modifier: string) => `${componentName}--${modifier}`);
    return [componentName, ...modifierClasses].join(" ");
}

export function camelToSnakeCase(text: string): string {
    return text
        .replace(/(.)([A-Z][a-z]+)/, "$1_$2")
        .replace(/([a-z0-9])([A-Z])/, "$1_$2")
        .toLowerCase();
}
